import './Legal.css';

export default function Refund() {
  return (
    <div className="legal-page">
      <div className="legal-card">
        <div className="legal-header">
          <span className="mono legal-tag">PuzzleForge</span>
          <h1 className="mono">Refund Policy</h1>
          <p className="legal-date mono">Last updated: March 24, 2026</p>
        </div>
        <div className="legal-body">

          <section>
            <h2>1. All Sales Final</h2>
            <p>All purchases and subscription payments for PuzzleForge Premium are final and non-refundable. By completing a purchase, you acknowledge and agree to this policy.</p>
          </section>

          <section>
            <h2>2. Cancellations</h2>
            <p>You may cancel your subscription at any time from your account settings. Cancellations take effect at the end of the current billing period. You will retain full access to Premium features until that date. No partial refunds are issued for unused time.</p>
          </section>

          <section>
            <h2>3. Exceptions</h2>
            <p>In cases of verified technical failures that completely prevented access to the Service for an extended period, we may at our sole discretion issue account credits. Contact us at <a href="mailto:support@puzzleforge.io">support@puzzleforge.io</a> to report such issues.</p>
          </section>

          <section>
            <h2>4. Payment Processing</h2>
            <p>All payments are processed by Paddle.com as our Merchant of Record. For payment disputes, contact <a href="mailto:support@puzzleforge.io">support@puzzleforge.io</a>.</p>
          </section>

          <section>
            <h2>5. Contact</h2>
            <p>For questions about this policy: <a href="mailto:support@puzzleforge.io">support@puzzleforge.io</a></p>
          </section>

        </div>
      </div>
    </div>
  );
}
